import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"
import { toast } from "./sonner-utils"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      offset={16}
      toastOptions={{
        duration: 3000,
        style: {
          maxWidth: '90vw',
          width: 'auto',
          padding: '8px 12px',
          fontSize: '13px',
          minHeight: 'auto',
        },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg text-xs sm:text-sm max-w-[90vw] sm:max-w-[400px]",
          description: "group-[.toast]:text-muted-foreground text-xs",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground text-xs sm:text-sm",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground text-xs sm:text-sm",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
